export const styles = theme => ({
  centerMiddleContainer: {
    zIndex: 1000,
    position: 'absolute',
    top: 'calc(50% - 20px)',
    left: 'calc(50% - 20px)'
  }
});
